export function Container({ className = '', children, ...props }) {
  const classes = [
    'mx-auto',
    'max-w-7xl',
    'px-4',
    'sm:px-6',
    'lg:px-8',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}

